<template>
    <div :id="componentId">
        <label v-if="label">{{ label }}</label>
        <div style="display: flex">
            <slot></slot>
        </div>
    </div>

</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class LabeledSelect extends Vue {
    @Prop({type: String}) label!: string;
    private componentId: string = "oc" + Math.random().toString(36).substr(2, 6);

}
</script>

<style lang="scss" scoped>
label {
    @include fontCaption();
    margin-bottom: 3px;
}
@media only screen and (max-width: $breakPoint - 1px){
    label {
        font-size: 12px;
    }
}
</style>
